import { useGlossaryTerms } from '@/services'
import { useParams, useNavigate } from 'react-router-dom'
import { paths } from '@/routes/paths'

export const TermDetailPage = () => {
  const { patientId, termId } = useParams<{ patientId: string; termId: string }>()
  const navigate = useNavigate()
  const { data: terms = [], isLoading } = useGlossaryTerms(patientId!)
  const term = terms.find((t) => t.id === termId)

  if (isLoading || !term) {
    return (
      <div className="max-w-content w-full flex flex-col gap-4">
        <button
          type="button"
          onClick={() => navigate(`/home/${patientId}/${paths.icuGlossary}`)}
          className="text-primary mb-2 hidden md:block"
        >
          ← Zurück
        </button>
        <p className="text-textBase text-b90">Begriff wird geladen...</p>
      </div>
    )
  }

  const paragraphs = term.full_description
    ? term.full_description.split(/\n\n+/).filter(Boolean)
    : []

  return (
    <div className="max-w-content w-full flex flex-col gap-4">
      <button
        type="button"
        onClick={() => navigate(`/home/${patientId}/${paths.icuGlossary}`)}
        className="text-primary self-start hidden md:block"
      >
        ← Zurück
      </button>
      <h1 className="text-h4 text-b100">{term.term}</h1>
      {term.layman_term && <p className="text-textBase text-b50">{term.layman_term}</p>}
      {term.short_description && (
        <p className="text-textBase font-medium text-b90">{term.short_description}</p>
      )}
      <div className="flex flex-col gap-3">
        {paragraphs.map((para, i) => (
          <p key={i} className="text-textBase text-b90 leading-relaxed">
            {para}
          </p>
        ))}
      </div>
      {term.links && term.links.length > 0 && (
        <div className="flex flex-col gap-2 pt-2 border-t border-sec30">
          <h2 className="text-textBase font-semibold text-b100">Weitere Informationen</h2>
          <ul className="flex flex-col gap-1.5">
            {term.links.map((link, i) => (
              <li key={i}>
                <a
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-textBase text-primary underline hover:no-underline"
                >
                  {link.label || link.url}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  )
}
